import { defineStore } from "pinia";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";

export const useNotificationStore = defineStore({
  id: "Notification",
  state: () => {
    return {
      status: "",
      last: null,
      open: false,
      messages: [],
      list: [],
      listOpened: false,
      refreshComponentKey: 0,
    };
  },

  actions: {
    setStatus(status) {
      this.status = status;
    },
    incrementRefreshComponentKey() {
      this.refreshComponentKey = this.refreshComponentKey + 1;
    },
    setLast(notification) {
      this.notification = notification;
    },
    setOpen(open) {
      this.open = open;
      if (this.status === messengerMessageManager.STATUS_SUCCESS && open) {
        this.setStatus(messengerMessageManager.STATUS_OFF);
      }
    },
    addMessage(message) {
      this.messages.unshift(message);
    },
    setList(list) {
      this.list = list;
    },
    setListOpened(value) {
      this.listOpened = value;
    },

    init() {
      this.status = "";
      this.last = null;
      this.open = false;
      this.messages = [];
      this.list = [];
      this.listOpened = false;
      this.refreshComponentKey = 0;
    },
  },
});
